//
//
//
//
//
//
//
//
//
//
//
//

export default {
	name: 'errorLayouts',
	props: [ 'error' ],
};
